var s;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(s || (s = {}));
var n;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand";
})(n || (n = {}));
var i;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(i || (i = {}));
var t;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(t || (t = {}));
var g;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(g || (g = {}));
var c;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered", e.RegisteredAndLogged = "registered", e.NotRegisteredAndNotLogged = "non_registered_nor_logged", e.RegisteredOrLogged = "registered_all", e.RegisteredAndNotLogged = "registered_non_logged", e.NotLogged = "non_registered";
})(c || (c = {}));
var u;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(u || (u = {}));
var f;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(f || (f = {}));
var v;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.Background = "background", e.Overlay = "overlay";
})(v || (v = {}));
var h;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(h || (h = {}));
var l;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(l || (l = {}));
var p;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(p || (p = {}));
var o;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(o || (o = {}));
var d;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(d || (d = {}));
var m;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(m || (m = {}));
var _;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Hide = "hide", e.EmptyClick = "empty-click", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.Login = "login", e.LastSearch = "send-to-last-search", e.TranslateDocumentBody = "translate-document-body";
})(_ || (_ = {}));
var b;
(function(e) {
  e.Resend = "resend", e.Signup = "signup", e.Signin = "signin", e.Validation = "validation";
})(b || (b = {}));
var r;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(r || (r = {}));
var w;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit", e.LastSearch = "send_to_last_search";
})(w || (w = {}));
var S;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(S || (S = {}));
var X;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(X || (X = {}));
var y;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(y || (y = {}));
var k;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(k || (k = {}));
var N;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(N || (N = {}));
var a;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(a || (a = {}));
var C;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(C || (C = {}));
var R;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(R || (R = {}));
var I;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})(I || (I = {}));
var x;
(function(e) {
  e.Date = "date", e.Time = "time";
})(x || (x = {}));
var B;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(B || (B = {}));
var E;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(E || (E = {}));
var U;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(U || (U = {}));
var G;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(G || (G = {}));
var H;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(H || (H = {}));
var P;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})(P || (P = {}));
var j;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(j || (j = {}));
var D;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(D || (D = {}));
var W;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(W || (W = {}));
var q;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(q || (q = {}));
var O;
(function(e) {
  e.Bar = "bar", e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.SlideIn = "slide-in", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(O || (O = {}));
var V;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(V || (V = {}));
const z = {
  [r.NowViewing]: "There are XXXXXX people looking at this hotel right now",
  [r.TodayViewed]: "XXXXXX people have looked at this hotel today",
  [r.BookedToday]: "XXXXXX people have already booked today",
  [r.LastReservation]: "Last reservation was XXXXXX hours ago",
  [r.DiscountToday]: "XXXXXX% discount only today",
  [r.TodaySpecialOffer]: "Today's special offer: XXXXXX"
}, M = {
  [a.None]: "none",
  [a.SubjectToAvailibity]: "Subject to availability",
  [a.WebExclusive]: "Web exclusive",
  [a.OnlyForRegisterdUsers]: "Only for registered users",
  [a.OnlyForSpecificRates]: "Only for specific rates"
};
export {
  d as B,
  x as C,
  P as D,
  l as F,
  k as L,
  o as M,
  C as P,
  p as R,
  h as T,
  O as a,
  X as b,
  _ as c,
  m as d,
  N as e,
  w as f,
  y as g,
  s as h,
  z as i,
  q as j,
  B as k,
  H as l,
  E as m,
  U as n,
  G as o,
  M as p,
  b as q
};
//# sourceMappingURL=maps.CaEU0IGW.js.map
